import React from 'react';
import Sidebar from '../../components/widgets/sidebar';
import SidebarBase from './Base';

export default class SidebarSubCustomer extends SidebarBase {

  render() {
    return (
      <>
        <Sidebar.Item path="/dashboard/devices" text="لیست دستگاه‌ها" icon="fal fa-sensor" />
      </>
    );
  }

}
